import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetAccessControlerDeviceByPage(params) {
  return maintainRequest.get(
    `/device/maintenanceMan/accessDevice/getAccessControlDeviceByPage`,
    {
      params,
    }
  );
}
